import { createTheme } from "@mantine/core";

export const mantineTheme = createTheme({});
